import { FC } from 'react'
import { useRouterPush } from '@/client/hooks'
import { Calculator } from '@/client/submodules/Calculator'
import Page from '@/client/submodules/Page'
import About from './About'
import Advantages from './Advantages'
import Hero from './Hero'
import Labels from './Labels'
import References from './References'
import Services from './Services'
import * as S from './styles'
import { HomeProps } from './types'

export const Home: FC<HomeProps> = ({
  seo,
  header,
  footer,
  content: { hero, labels, about, advantages, references, services }
}) => {
  const { defaultLocale } = useRouterPush()

  return (
    <Page seo={seo} header={header} footer={footer}>
      <S.WrapHeroCalculator>
        <Hero hero={hero} />
        <S.WrapCalculator id='calculator'>
          <Calculator serviceType={defaultLocale || process.env.NEXT_PUBLIC_DEFAULT_LOCALE} />
        </S.WrapCalculator>
      </S.WrapHeroCalculator>
      <Labels labels={labels} />
      <Services services={services} />
      {process.env.NEXT_PUBLIC_DEFAULT_LOCALE !== 'au' && <Advantages advantages={advantages} />}
      <About about={about} />
      {process.env.NEXT_PUBLIC_DEFAULT_LOCALE !== 'us' && <References references={references} />}
    </Page>
  )
}
